import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

// Antd Components
import { Modal, Input, message, InputNumber } from "antd";
import instance from "@/store/actions/instance";

class newCashMovementModal extends Component {
  state = {
    saveLoading: false,
    amount: null,
    note: null,
  };

  createCashMovement = async () => {
    this.setState({ saveLoading: true });
    const { t, movementType, selectedRegister, getRegisterSummary } =
      this.props;
    const { amount, note } = this.state;
    console.log(selectedRegister);
    try {
      const res = await instance.post("/create_register_cash_movement/", {
        closingId:
          selectedRegister.last_opening || selectedRegister.last_opening_id,
        amount: movementType === "add" ? amount : -amount,
        note: note,
      });
      message.success(t("Created successfully"));

      this.props.onClose();
      getRegisterSummary();
    } catch (err) {
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(t("SomethingWentWrong"));
    }
    this.setState({ saveLoading: false });
  };

  saveButtonDisabled = () => {
    const { amount } = this.state;
    return !amount;
  };

  render() {
    const { visible, config, t, movementType } = this.props;
    const { saveLoading } = this.state;

    return (
      <Modal
        style={{ top: 20 }}
        destroyOnClose={true}
        title={
          <div
            className="ant-modal-title"
            style={{
              textAlign: config.direction == "rtl" ? "right" : "left",
            }}
          >
            {movementType === "add" ? t("Add Cash") : t("Remove Cash")}
          </div>
        }
        visible={visible}
        onCancel={() => this.props.onClose()}
        onOk={() => {
          this.createCashMovement();
        }}
        okText={t("Save")}
        cancelText={t("Close")}
        bodyStyle={{
          paddingTop: 0,
          width: "auto",
          padding: "0px 18px",
          textAlign: config.direction == "ltr" ? "left" : "right",
        }}
        okButtonProps={{
          disabled: this.saveButtonDisabled(),
          loading: saveLoading,
        }}
      >
        <div className="px-2 mb-3">
          <div className="mt-3">
            <p>{t("Amount")}</p>
            <InputNumber
              className="w-100"
              placeholder={t("Amount")}
              min={0}
              onChange={(value) => this.setState({ amount: value })}
            />
          </div>
          <div className="mt-3">
            <p>{t("Note")}</p>
            <Input
              className="w-100"
              placeholder={t("Note")}
              onChange={(e) => this.setState({ note: e.target.value })}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    selectedRegister: state.pos.selectedRegister,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(newCashMovementModal));
